import Grid from 'apollo-react/components/Grid';
import React from 'react';

import ControlPropertiesTable from './ControlPropertiesTable';
import { useFormSelector } from '../../../../custom-hooks';
import { getUITA } from '../../../../utils/commonUtils';
import { FORM_MODEL_ATTRIBUTES } from '../../../constants/form-manager.constants';
import {
  getDeltaChangesByControl,
  getRules,
  hasControlPropChanges,
} from '../../../selectors/editor.selectors';
import { equalityFn } from '../../../utils/form-manager.utils';

const columns = [
  {
    header: 'Type',
    accessor: 'dummyType',
  },
  {
    header: 'Parameter',
    accessor: 'dummyParameter',
  },
];

const ControlPropertiesValidation = ({ controlId, classes, handleClick }) => {
  const validationRules = useFormSelector(
    getRules,
    {
      id: controlId,
      prop: FORM_MODEL_ATTRIBUTES.VALIDATION,
    },
    equalityFn
  );

  const formChangesValidation = useFormSelector(
    getDeltaChangesByControl,
    {
      id: controlId,
      name: FORM_MODEL_ATTRIBUTES.VALIDATION,
    },
    equalityFn
  );
  const deltaChanges = !!(formChangesValidation && formChangesValidation.length);

  const hasUIChange = useFormSelector(
    hasControlPropChanges,
    {
      id: controlId,
      prop: 'validation',
    },
    equalityFn
  );

  return (
    <Grid item xs={12} ui-ta={getUITA('Control Properties Validation')}>
      <ControlPropertiesTable
        title="Validation"
        type="validation"
        classes={classes}
        columns={columns}
        rows={validationRules}
        hasUIChange={hasUIChange}
        deltaChanges={deltaChanges}
        handleClick={handleClick}
      />
    </Grid>
  );
};

export default React.memo(ControlPropertiesValidation);
